import { SearchOutlined } from '@ant-design/icons';
import { Input, Button, Space } from 'antd';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ArticlesSearchBar.module.scss';

interface Props {
  onSearch: (searchString: string) => void;
  className?: string;
}

export function ArticlesSearchBar(props: Props) {
  const { onSearch, className } = props;
  const [query, setQuery] = useState<string>('');
  const { t } = useTranslation();

  return (
    <Space className={classNames(styles.container, 'mb-2', className)}>
      <Input
        className={styles.searchInput}
        value={query}
        placeholder={t('articles.search.placeholder')}
        onChange={(e) => {
          const val = e.target.value;
          setQuery(val);
          if (val === '') {
            onSearch('');
          }
        }}
        allowClear
      />

      <Button
        type="link"
        icon={<SearchOutlined />}
        onClick={() => onSearch(query)}
        className={styles.searchButton}
      />
    </Space>
  );
}
